/**
 * Shape-only validation of a public form slug.
 *
 * Mirrors `token.ts` (`isShapeValidToken`): a shape-invalid slug must never reach
 * the donation-form view — it falls through to the generic ErrorView. Accepts a
 * lowercase, hyphen-separated slug: `^[a-z0-9]+(?:-[a-z0-9]+)*$`.
 */
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export function isShapeValidSlug(value) {
    if (typeof value !== "string") {
        return false;
    }
    return SLUG_PATTERN.test(value);
}
